import { Component, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { DeviceInfoService } from 'src/app/services/device-info.service';
import { LocationService } from 'src/app/services/location.service';

@Component({
  selector: 'app-location-permission-required',
  templateUrl: './location-permission-required.page.html',
  styleUrls: ['./location-permission-required.page.scss'],
})
export class LocationPermissionRequiredPage implements OnInit {
  gpsPermission: string;
  platform: string;
  browserName: string;
  browserVersion: string;
  os: string;
  osMajorVersion: number;
  interval: NodeJS.Timeout;
  constructor(
    private locationService: LocationService,
    private deviceInfoService: DeviceInfoService,
    private modalController: ModalController
  ) { }

  async ngOnInit() {
    this.loadDeviceInfo()
    this.gpsPermission = await this.locationService.getLocationPermission();
  }

  onPermissionGranted() {
    clearInterval(this.interval);
    this.modalController.dismiss({ granted: true }, 'confirm');
  }

  async loadDeviceInfo() {
    this.platform = await this.deviceInfoService.getPlatform();
    this.os = await this.deviceInfoService.getOS();
    if (this.platform === "web") {
      this.browserName = this.deviceInfoService.getBrowserName();
    } 
    else {
      this.osMajorVersion = await this.deviceInfoService.getOSMajorVersion();
    }
  }

  async turnOnGPS() {
    await this.locationService.requestLocationPermission()
      .catch((error) => console.log(error));

    this.gpsPermission = await this.locationService.getLocationPermission();
    if (this.gpsPermission === "granted") {
      this.onPermissionGranted();
    }
  }

  closePage() {
    this.modalController.dismiss(null, 'cancel');
  }
}
